// Add shared constants here and export them.
const { DOSAGE_FORMS, WEIGHT_DOSED_FORMS } = require('./medicine');

module.exports = { DOSAGE_FORMS, WEIGHT_DOSED_FORMS };
